import {
  ActivityChangeExtensionOptions,
  createActivityChangeExtension,
  createActivityChangeExtensions,
  useActivityChangeExtensions,
} from '@spotify/plugin-confidence-activity-react';

export const FlagUpdatesChangeExtensions = createActivityChangeExtensions(
  'flag-updates-change',
);

export const useFlagUpdatesChangeExtensions = () => {
  return useActivityChangeExtensions(FlagUpdatesChangeExtensions);
};

export const createFlagUpdatesChangeExtension = (
  options: ActivityChangeExtensionOptions,
) => {
  return createActivityChangeExtension(options);
};
